/* eslint-disable react/prop-types */
import React from 'react'
import './HomeView.scss'
import * as Navigator from '../../../modules/Navigator'
import auth from '../../../auth/service'
import { locales, loginText, titlePartOne, titlePartTwo } from '../libs/locales'

export class HomeView extends React.Component {
  constructor (props) {
    super(props)
    auth.loginCallback = this.loggedIn.bind(this)
  }

  componentDidMount () {
    if (auth.isAuthenticated()) {
      Navigator.goToPage(Navigator.DASHBOARD_PAGE)
    }
  }

  loggedIn () {
    Navigator.goToPage(Navigator.DASHBOARD_PAGE)
    this.props.setUserLocale(auth.getLocale())
  }

  // TODO: remove the login page, infoUser redux
  render () {
    const { userLocale } = this.props
    return (<div id='home'>
      <nav>
        <ul>
          <li><a onClick={() => auth.login()} className='menu-item'>{locales[userLocale.data][loginText]}</a></li>
          <li className='slide' />
        </ul>
      </nav>
      <section>
        <div className='title'>
          <span>
            <img src='images/welovesurveys.png' />
          </span>
          <span>{locales[userLocale.data][titlePartOne]}<a className='underlined'>{locales[userLocale.data][titlePartTwo]}</a></span>
        </div>
      </section>
    </div>)
  }
}

export default HomeView



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomeView.js